import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function CS537() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">Project Title</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              This page is under construction, please visit other project
              repositories on my GitHub page.
            </Box>
            <Box mt={4} className="title">
              Demo
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default CS537;
